import { partyMasterConfig } from './partyMaster';

/**
 * Agent master (redesigned 2026-10-16, migration 036). Like Sellers and Dispatchers an agent holds one or more currencies, each with its own opening balance and an
 * optional credit limit. A balance in a currency is what the agent owes you; amber means it is over the credit limit, red means you owe the agent.
 */
export const agentsConfig = partyMasterConfig({
  title: 'Agents', singular: 'agent', icon: 'person-badge', menu: 'agents', endpoint: '/agents',
  balances: 'agents', idKey: 'agentId', lookup: 'agents', balanceHeader: 'Outstanding balance',
  directions: [{ value: 'owes', label: 'Agent owes you' }, { value: 'advance', label: 'You owe the agent' }],
  tips: ['Agent owes you', 'You owe the agent'],
  totalsTitle: 'Owed by agents (active), by currency',
  note: 'Balance in a currency is what the agent owes you. Amber means over the credit limit. Red means you owe the agent.',
  currenciesHelp: 'The agent shows in dropdowns only for these currencies',
  activeHelp: 'Inactive agents are hidden from dropdowns',
  locationHelp: 'For example Dubai, Deira',
  extra: {
    apiField: 'creditLimit', label: 'Credit limit', help: 'Warn when over', kind: 'over',
    tip: (amount) => `Over the credit limit of ${amount}`,
    filter: { param: 'overLimit', label: 'Over limit only' },
  },
});
